import { merge, get, set } from 'lodash';
import { ADMIN } from '../../../actionTypes';
let initState = {
	adminMainList: [],
	count: 10
};
export function AdminMainReducers(state = initState, action) {
	switch (action.type) {
		case ADMIN.FETCH_ADMINMAIN_LIST: {
			let { list, count } = get(action, 'payload', {});
			if (get(list, 'length') > 0) {
				merge(state, {}, { count });
				state.adminMainList = list;
				return merge({}, state, {});
			}
			return state;
		}
		default:
			return state;
	}
}
